import { render, staticRenderFns } from "./VConfirmationModal.vue?vue&type=template&id=1b7525d3&"
import script from "./VConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./VConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./VConfirmationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports